/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPlayIcon20Light = forwardRef('MediaUiAPlayIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 3.913a1.3 1.3 0 0 1 1.969-1.115l10.145 6.087a1.3 1.3 0 0 1 0 2.23L5.969 17.202A1.3 1.3 0 0 1 4 16.087V3.913Zm1.454-.257A.3.3 0 0 0 5 3.913v12.174a.3.3 0 0 0 .454.257L15.6 10.257a.3.3 0 0 0 0-.514L5.454 3.656Z" })));
});
